<foo-control-label [templateOptions]="templateOptions" [control]="control"></foo-control-label>

<mat-form-field appearance="fill" class="datepicker timepicker">
  <input matInput
         [ngxMatTimepicker]="picker"
         [formControl]="control"
         [format]="timeFormat"
         [max]="$any(max)"
         [min]="$any(min)"
         [placeholder]="templateOptions?.placeholder| translate"
         class="input-calendar cursor-pointer"
         dir="ltr"
         readonly>
  <mat-icon matSuffix (click)="picker.open()" class="cursor-pointer">
    <span class="foo-icon" [class]="icon"></span>
  </mat-icon>

  <ng-container *ngIf="control?.value && clearable">
    <div matDatepickerToggleIcon class="custom-clear-input" (click)="clearInput()"><span class="ng-clear"></span></div>
  </ng-container>

  <ngx-mat-timepicker color="primary" #picker
                      class="foo-timepicker"
                      [cancelBtnTmpl]="cancelBtn"
                      [confirmBtnTmpl]="confirmBtn"
  >
  </ngx-mat-timepicker>
  <ng-template #cancelBtn>
    <button mat-button color="primary" class="mr-10">
      {{ 'timePicker.cancel' | translate }}
    </button>
  </ng-template>

  <ng-template #confirmBtn>
    <button mat-button color="primary">
      {{ 'timePicker.ok' | translate }}
    </button>
  </ng-template>
</mat-form-field>


<foo-control-errors *ngIf="!templateOptions?.readonly && !templateOptions?.hideErrors" [control]="control"
                    [errorMessages]="errors"></foo-control-errors>
